let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fj3iY")).then(() => parcelRequire('4k82d'));